import { getLocales } from 'assets/locales/Locale';
import { usePriceSelectionTools } from '../hooks/usePriceSelectionTools';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import Icon from 'assets/components/icon/Icon';
import { usePriceEditor } from '../hooks/usePriceEditor';

export default function PriceAdjustmentSelectionTools() {
  const { lang } = getLocales();
  const priceSelectionTools = usePriceSelectionTools();
  const { prices, permissions } = usePriceEditor();
  const hasDistributorPrices = prices.some((it) => !!it.distributor?.distributions);

  return (
    <InputWrapper>
      {!!priceSelectionTools.distributors.length && !permissions.specificUserType && (
        <SelectInput
          name="distributorId"
          value={priceSelectionTools.distributor?.id}
          label={lang.distributors}
          data={priceSelectionTools.distributors?.map((d) => ({
            id: d.id,
            title: d.name,
          }))}
          onChange={({ distributorId }) => priceSelectionTools.onSelect({ distributorId })}
          style={{ width: '200px' }}
        />
      )}
      {!!priceSelectionTools.templates.length &&
        (!permissions.specificUserType || permissions.specificUserType === 'distributor') && (
          <SelectInput
            name="distributorTemplateId"
            value={priceSelectionTools.distributorTemplate?.id}
            label={lang.pricingDistributionTemplate}
            data={priceSelectionTools.templates?.map((t) => ({
              id: t.id,
              title: t.name,
              subtitle: t.distributor?.name,
              disabled:
                hasDistributorPrices && !!priceSelectionTools.distributorTemplate?.id
                  ? priceSelectionTools.distributorTemplate?.id !== t.id
                  : (priceSelectionTools.alreadyUsedTemplateId
                      ? priceSelectionTools.alreadyUsedTemplateId !== t.id
                      : false) || priceSelectionTools.distributor?.id !== t.distributorId,
            }))}
            onChange={({ distributorTemplateId }) =>
              priceSelectionTools.onSelect({
                distributorTemplateId,
                distributorId: priceSelectionTools.distributor?.id,
                dealerId: priceSelectionTools.dealer?.id,
              })
            }
            style={{ width: '200px' }}
          />
        )}
      {!!priceSelectionTools.dealers.length && (
        <SelectInput
          name="dealerId"
          value={priceSelectionTools.dealer?.id}
          label={lang.dealers}
          data={priceSelectionTools.dealers?.map((d) => ({
            id: d.id,
            title: d.name,
            subtitle: d.representative?.name,
            actionIcon: <Icon class="fas-copy" />,
            actionTitle: lang.copyAdjustementsToThisDealer,
            disableEdit:
              !priceSelectionTools.dealer ||
              priceSelectionTools.dealer?.id === d.id ||
              !priceSelectionTools.distributor ||
              d.representativeId !== priceSelectionTools.distributor?.id,
          }))}
          onChange={({ dealerId }) => {
            if (dealerId) {
              const distributorId = priceSelectionTools.dealers?.find((it) => it.id === dealerId)?.representativeId;

              priceSelectionTools.onSelect({
                dealerId,
                distributorId,
                distributorTemplateId:
                  priceSelectionTools.distributorTemplate?.distributorId === distributorId
                    ? priceSelectionTools.distributorTemplate?.id
                    : undefined,
              });
            } else {
              priceSelectionTools.onSelect({
                distributorTemplateId: priceSelectionTools.distributorTemplate?.id,
                distributorId: priceSelectionTools.distributor?.id,
              });
            }
          }}
          style={{ width: '200px' }}
          //onEdit={(id) => dealerPricingSettings.copyTo(id, addProgressToWindow)}
        />
      )}
    </InputWrapper>
  );
}
